import { useEffect, useState } from 'react';
import { getUserReferralSummary } from '../api';

const fmt = (n) =>
    new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 0 }).format(
        Number(n) || 0
    );

export default function UserSummaryPanel({ userId }) {
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!userId) {
            setSummary(null);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setError('');

        getUserReferralSummary(userId)
            .then((data) => {
                if (!cancelled) setSummary(data);
            })
            .catch((e) => {
                if (!cancelled) setError(e.message);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [userId]);

    if (!userId) return null;
    if (loading) return <div className="user-summary-loading">در حال بارگذاری...</div>;
    if (error) return <div className="error-banner">{error}</div>;
    if (!summary) return null;

    const { user, stats, total_pending, total_paid, total_commissions } = summary;

    return (
        <div className="user-summary-panel">
            <div className="user-summary-header">
                <h3>
                    {[user.first_name, user.last_name].filter(Boolean).join(' ') || user.mobile_phone}
                </h3>
                {user.referral_code && (
                    <code className="user-summary-code">{user.referral_code}</code>
                )}
            </div>

            <div className="user-summary-grid">
                <div className="user-summary-item">
                    <span>کل پورسانت‌ها</span>
                    <strong>{fmt(total_commissions)}</strong>
                </div>
                <div className="user-summary-item">
                    <span>در انتظار</span>
                    <strong className="text-warning">{fmt(total_pending)} ریال</strong>
                </div>
                <div className="user-summary-item">
                    <span>پرداخت شده</span>
                    <strong className="text-success">{fmt(total_paid)} ریال</strong>
                </div>
                <div className="user-summary-item">
                    <span>معرفی مستقیم</span>
                    <strong>{fmt(stats.direct_count)} نفر</strong>
                </div>
                <div className="user-summary-item">
                    <span>کل زیرمجموعه</span>
                    <strong>{fmt(stats.total_count)} نفر</strong>
                </div>
                <div className="user-summary-item">
                    <span>کل درآمد از معرفی</span>
                    <strong className="text-success">{fmt(stats.total_earned)} ریال</strong>
                </div>
            </div>
        </div>
    );
}